import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PageHeader, Empty } from "@/components/common";
import { api, API } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export default function Insights() {
  const [text, setText] = useState("");
  const [at, setAt] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/ai/insights/latest").then((r) => { if (r.data.content) { setText(r.data.content); setAt(r.data.created_at); } }); }, []);

  const generate = async () => {
    setBusy(true);
    setText("");
    try {
      const res = await fetch(`${API}/ai/insights`, { method: "POST", credentials: "include", headers: { Authorization: `Bearer ${localStorage.getItem("bf_token")}` } });
      if (!res.ok) throw new Error(`Request failed (${res.status})`);
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let buf = "";
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        const parts = buf.split("\n\n");
        buf = parts.pop();
        for (const p of parts) {
          if (!p.startsWith("data: ")) continue;
          const ev = JSON.parse(p.slice(6));
          if (ev.text) setText((t) => t + ev.text);
          if (ev.error) toast.error(ev.error);
        }
      }
      setAt(new Date().toISOString());
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="insights-page">
      <PageHeader eyebrow="AI advisor" title="Forecasts & smart suggestions" subtitle="Claude reads your last 30 days of orders, costs, stock and credit, then tells you what to produce, what to buy and whom to chase for payment.">
        <Button onClick={generate} disabled={busy} className="rounded-full bg-[#D96B43] hover:bg-[#c55d38]" data-testid="generate-insights-btn">
          {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Sparkles className="mr-2 h-4 w-4" />}{busy ? "Thinking..." : "Generate insights"}
        </Button>
      </PageHeader>
      {!text && !busy && <Empty icon={Sparkles} title="No insights yet" text="Tap Generate insights to get your demand forecast and reorder plan." testid="insights-empty" />}
      {(text || busy) && (
        <div className="rounded-3xl border border-[#E7E2D6] bg-white p-6 sm:p-10 shadow-sm" data-testid="insights-content">
          {at && !busy && <div className="text-xs text-muted-foreground mb-4">Generated {fmtDateTime(at)}</div>}
          <div className="bf-md max-w-3xl"><ReactMarkdown>{text || "..."}</ReactMarkdown></div>
        </div>
      )}
    </div>
  );
}
